<template>
  <div class="helpsWrap">
    <div class="searchWrap">
      <span class="label">{{ $tt("问题：") }} </span>
      <el-input
        v-model="searchKeyword"
        :placeholder="$tt('请输入关键词，支持模糊搜索')"
        clearable
        @keyup.enter.native="onSearch"
      />
      <el-button type="primary" icon="el-icon-search" @click="onSearch">
        {{ $tt("搜索") }}
      </el-button>
    </div>

    <div v-if="loading" class="helps-loading">
      <i class="el-icon-loading" />
    </div>
    <el-empty
      v-else-if="!(documentsData.result || []).length"
      :description="$tt('暂无帮助文档')"
    />
    <el-row v-else :gutter="20" class="documents">
      <el-col
        v-for="d in documentsData.result || []"
        :key="d.id"
        :xs="12"
        :sm="8"
        :md="6"
        :lg="6"
        class="document-col"
      >
        <div class="help-book" @click="openDetail(d.id)">
          <div class="help-book__spine" aria-hidden="true" />
          <div class="help-book__page">
            <div class="help-book__title" :title="d.question">{{ d.question }}</div>
            <div class="help-book__excerpt">{{ excerpt(d.answer) }}</div>
            <span class="help-book__link">{{ $tt("查看详情") }} &gt;</span>
          </div>
        </div>
      </el-col>
    </el-row>

    <div class="footer" v-if="documentsData.total > 0">
      <Pagination
        ref="pagination"
        :handleSizeChange="handleSizeChange"
        :handleCurrentPageChange="handleCurrentPageChange"
        :total="documentsData.total"
        :page-sizes="[8, 12, 16, 24]"
      />
    </div>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";

export default {
  components: { Pagination },
  data() {
    return {
      searchKeyword: "",
      documentsData: { result: [], total: 0 },
      loading: false,
      pageNum: 1,
      pageSize: 8,
    };
  },
  mounted() {
    this.fetchList();
  },
  methods: {
    excerpt(html) {
      if (!html) return "";
      const div = document.createElement("div");
      div.innerHTML = html;
      const text = (div.textContent || div.innerText || "").replace(/\s+/g, " ").trim();
      if (text) return text.length > 72 ? `${text.slice(0, 72)}…` : text;
      if (/<img/i.test(html)) return this.$tt("含图片说明");
      return "";
    },
    onSearch() {
      this.pageNum = 1;
      if (this.$refs.pagination) {
        this.$refs.pagination.currentPage = 1;
      }
      this.fetchList();
    },
    handleSizeChange(v) {
      this.pageSize = v;
      this.pageNum = 1;
      this.fetchList();
    },
    handleCurrentPageChange(v) {
      this.pageNum = v;
      this.fetchList();
    },
    fetchList() {
      this.loading = true;
      const keyword = (this.searchKeyword || "").trim();
      this.$request
        .queryHelpDocumentsList({
          page_num: this.pageNum,
          page_size: this.pageSize,
          instruction_name: keyword || undefined,
          question: keyword || undefined,
        })
        .then((res) => {
          if (res.status != "success") {
            this.$message.error(res.msg);
            return;
          }
          const data = res?.data || {};
          this.documentsData = {
            result: data.result || data.list || [],
            total: data.total ?? data.totalRecord ?? 0,
          };
        })
        .finally(() => {
          this.loading = false;
        });
    },
    openDetail(id) {
      this.$router.push({
        path: "/helps/edit",
        query: { id, noEdit: true },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.helpsWrap {
  background-color: #fff;
  min-height: 100%;
  .searchWrap {
    display: flex;
    border-bottom: 1px solid #e6e6e6;
    padding: 16px 24px;
    align-items: center;
    .label {
      flex-shrink: 0;
      margin-right: 8px;
    }
    .el-input {
      width: 280px !important;
      max-width: 40vw;
    }
    .el-button {
      margin-left: 12px;
    }
  }
  .helps-loading {
    padding: 48px;
    text-align: center;
    color: #909399;
    font-size: 28px;
  }
  .documents {
    padding: 24px 24px 8px;
  }
  .document-col {
    margin-bottom: 24px;
  }
  .help-book {
    position: relative;
    height: 200px;
    cursor: pointer;
    border-radius: 4px 10px 10px 4px;
    box-shadow: 0 6px 18px rgba(15, 23, 42, 0.1);
    transition: transform 0.2s ease, box-shadow 0.2s ease;
    &:hover {
      transform: translateY(-4px);
      box-shadow: 0 12px 28px rgba(15, 23, 42, 0.14);
    }
  }
  .help-book__spine {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 14px;
    border-radius: 4px 0 0 4px;
    background: linear-gradient(90deg, #8b7355 0%, #c4a574 40%, #a08050 100%);
    box-shadow: inset -2px 0 4px rgba(0, 0, 0, 0.15);
  }
  .help-book__page {
    position: absolute;
    left: 10px;
    right: 0;
    top: 0;
    bottom: 0;
    padding: 16px 14px 12px 18px;
    background: linear-gradient(135deg, #fffef8 0%, #f5f0e4 48%, #ebe4d4 100%);
    border: 1px solid #e8dcc8;
    border-left: none;
    border-radius: 0 10px 10px 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    &::before {
      content: "";
      position: absolute;
      left: 0;
      top: 8px;
      bottom: 8px;
      width: 1px;
      background: rgba(139, 115, 85, 0.25);
    }
  }
  .help-book__title {
    font-size: 15px;
    font-weight: 600;
    color: #3d3428;
    line-height: 1.45;
    max-height: 2.9em;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    flex-shrink: 0;
  }
  .help-book__excerpt {
    flex: 1;
    margin-top: 10px;
    font-size: 13px;
    color: #7a6f5c;
    line-height: 1.5;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }
  .help-book__link {
    flex-shrink: 0;
    margin-top: 8px;
    font-size: 12px;
    color: #409eff;
  }
  .footer {
    padding: 8px 24px 24px;
    display: flex;
    justify-content: flex-end;
  }
}
</style>
